import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';

const SecurityModal = ({ s }) => {
  const { t } = useTranslation('upload');
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <div className={s['security-message__holder']}>
      <strong className={s['security-message__modal']} onClick={showModal}>
        {t('securityModal.modalOpen')}
      </strong>
      <Modal
        open={visible}
        title={<strong>{t('securityModal.modalContent.title')}</strong>}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button 
            key="submit" 
            className={s["ant-button_fixer"] + " btn btn--primary"}
            loading={loading} 
            onClick={handleOk}
          >
            {t('securityModal.modalContent.button')}
          </Button>,
        ]}
      >
        <p>{t('securityModal.modalContent.firstText')}</p>
        <p>
          {t('securityModal.modalContent.secondText')}
          <a 
            className={s['contact-link']} 
            href="mailto:leverans@marknadsinformation.se" 
            target="_top"
          >
            leverans@marknadsinformation.se
          </a>
        </p>
      </Modal>
    </div>
  );
};

export default SecurityModal;
